module.exports = ".title{\n    color: #2D419A;font-weight: bold;font-size: 25px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main